import React from 'react';

import classNames from 'classnames';

function Loading({ logo = false }) {
  return (
    <div className="w-100 h-100 pb-5">
      <div className="row d-flex justify-content-center v-center m-0">
        {logo && (
          <div className="col-12 text-center mb-4">
            <img src="/assets/images/HUTRICS_LOGO_HERE.svg" style={{ height: '50px' }} alt="HUTRICS_ALT_TEXT_HERE" />
          </div>
        )}
        <Spinner className="col-12 text-primary" style={{ width: '3rem', height: '3rem' }} />
        <div className="col-12 text-center text-primary mt-4">
          <p>Loading...</p>
        </div>
      </div>
    </div>
  );
}

export function Spinner({ className }) {
  return (
    <div className={classNames('spinner-border', className)} role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  );
}

export function SpinnerSm({ className }) {
  return <Spinner className={classNames('spinner-border-sm', className)} />;
}

export default Loading;
